// extracted by mini-css-extract-plugin
module.exports = {"categoryLabels":"styles_categoryLabels__sTqI1","categoryItem":"styles_categoryItem__m0JoI"};